import { orderBy } from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  siteGroups: [],
  grades: [],
  report: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.DEMOGRAPHICS_REPORT_GET_SITE_GROUPS:
      return {
        ...state,
        siteGroups: {
          ...payload.data,
          Data: orderBy(payload.data.Data, [x => x.Id]),
        },
      };
    case types.DEMOGRAPHICS_REPORT_GET_GRADES:
      return {
        ...state,
        grades: {
          ...payload.data,
          Data: orderBy(payload.data.Data, [x => x.Id]),
        },
      };
    case types.DEMOGRAPHICS_REPORT_GET_REPORT:
      return { ...state, report: payload };

    case types.DEMOGRAPHICS_REPORT_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.DEMOGRAPHICS_REPORT_FETCHING:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/demographics/state/demographicsreport/reducer.js